/*
 * サブシステム名：
 * 機能名：点呼簿
 */
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
// import validators from '@/rahmen/validators'

import d2fmt from '@/ddv2.library/utils/formatter'
import date from '@/ddv2.library/date'
import header from '@/ddv2.library/header'
import indexeddb from '@/ddv2.library/indexeddb'
// import modals from '@/ddv2.library/modals'

import DdCustomButton from '@/components/DdCustomButton'
import DdCodeTextBox from '@/components/DdCodeTextBox'
import DdDateBox from '@/components/DdDateBox'
import DdDropDown from '@/components/DdDropDown'
import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'
import DdMonthBox from '@/components/DdMonthBox'
import DdMonthBoxInside from '@/components/DdMonthBoxInside'
import DdSpreadSheet from '@/components/DdSpreadSheet'
import DdSubHeader from '@/components/DdSubHeader'
import DdSwitch from '@/components/DdSwitch'
import DdTransparentButton from '@/components/DdTransparentButton'
import VTour from '@/components/DdCoachMark.vue'
import CoachMark from './CoachMark/D2PLMT3010.js'

export default {
  name: 'HaishaMeisaiListEdit',
  mixins: [flowMixin],
  components: {
    VTour,
    DdCustomButton,
    DdCodeTextBox,
    DdDateBox,
    DdDropDown,
    DdIconButtonWithTooltip,
    DdMonthBox,
    DdMonthBoxInside,
    DdSpreadSheet,
    DdSubHeader,
    DdSwitch,
    DdTransparentButton
  },
  data: () => ({
    isConditionHide: false,
    isAfterSearch: false,
    isEditCategory: false,

    // ヘッダー定義
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstJininHeaders: header.mstJininHeaders,
    mstSharyoHeaders: header.vwCMstSharyoHeaders,

    // 検索用
    conditions: {},
    conditionDetails: [
      { key: 'sagyoYoteiYmd', name: '運行日', value: 'sagyoYoteiYmd', delete: false },
      // { key: 'haishahyoCd', name: '配車表', value: 'haishahyoNm', delete: false }
      { key: 'eigyoshoId', name: '配車営業所', value: 'haishaEigyoshoNm', delete: false }
      // { key: 'tableStartHourDisp', name: '開始時間', value: 'tableStartHourDisp', delete: false },
      // { key: 'rangeDisp', name: '表示範囲', value: 'rangeDisp', delete: false }
    ],
    searchText: null,

    // 初期表示用時間定義
    tableStartHourDisp: '6:00',
    // tableStartHour: 6, - computedへ
    rangeDisp: '24時間',
    rangeDispList: ['24時間', '48時間', '3日', '5日', '7日'],

    // 表示用
    headers: [],
    rows: [],

    // Formula
    seikyuKingakuGokeiFormula: null,
    shiharaiKingakuGOkeiFormula: null,

    // 保存用
    selected: [],
    targetList: [],
    // 制御用運行実績ID（新規の場合は-1から減らしていく）
    wkUnkoJissekiId: 0,
    // 操作ガイド用
    startCoachMark: false,
    steps: CoachMark.STEPS,
    startCoachMark2: false,
    steps2: CoachMark.STEPS2,

    modeKengen: 0,

    // スプレッドシートオプション
    option: {
      // テーブル最大高さ
      tableHeight: '60vh',
      // テーブル最大横幅
      tableWidth: 'inherit',
      // 列固定
      freezeColumns: 2,
      // 列追加
      allowInsertColumn: false,
      // 行追加※改行キーのみ
      allowManualInsertRow: false,
      // 列削除
      allowDeleteColumn: false,
      // 行削除
      allowDeleteRow: false,
      // 列ドラッグ
      columnDrag: false,
      // 行ドラッグ
      rowDrag: false,
      // ソート
      columnSorting: false,
      // スクロール有効化
      tableOverflow: true,
      // コンテキストメニュー
      contextmenu: false,
      // セル内HTML無効※ヘッダー改行のため有効
      stripHTML: false,
      // 計算式のサポート
      parseFormulas: true,
      // セル選択時の右下の■ドラッグでのコピー
      selectionCopy: true,
      // CSV出力
      allowExport: false,
      // フィルターオプション
      search: true,
      // ページネーションオプション
      pagination: 25,
      paginationOptions: [10, 20, 50, 100, 150, 200],
      // デフォルト文言変更
      text: {
        show: '1ページ当たりの行数:',
        entries: '',
        showingPage: '全部で {1} ページあります',
        search: 'さらにフリーワードで絞り込む',
        noRecordsFound: '対象データがありません'
      }
    },
    // 画面側からのエラーリスト
    outsideErrorList: []
  }),
  watch: {
    /**
     * 検索条件簡易表示用
     * @param {} n
     */
    // 配車表
    'conditions.haishahyoCd': function (n) {
      if ([undefined, null, ''].includes(this.conditions.haishahyoCd)) {
        this.conditions.haishahyoNm = null
      } else {
        const m = this.haishahyoList.find(x => x.haishahyoCd === this.conditions.haishahyoCd)
        if (m !== null) {
          this.conditions.haishahyoNm = m.haishahyoNm
        } else {
          this.conditions.haishahyoNm = null
        }
      }
    },
    // 配車表営業所
    'conditions.eigyoshoId': function (n) {
      if ([undefined, null, ''].includes(this.conditions.eigyoshoId)) {
        this.conditions.haishaEigyoshoNm = null
      } else {
        const m = this.eigyoshoList.find(x => x.id === this.conditions.eigyoshoId)
        if (m !== null) {
          this.conditions.haishaEigyoshoNm = m.eigyoshoNm
        } else {
          this.conditions.haishaEigyoshoNm = null
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      currentKaishaCode: 'users/currentKaishaCode',
      usersEigyoshoCd: 'users/eigyoshoCd',
      eigyoshoList: 'DDMasters/mstEigyosho',
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList',
      sharyoList: 'DDMasters/vwCMstSharyo',
      shubetsuList: 'DDMasters/mstShubetsu',
      kubunList: 'DDMasters/msysKubun'
    }),
    // ----------------------------------------------------------------------------------------------------
    // 検索条件用フィルタ
    // ----------------------------------------------------------------------------------------------------
    // 営業所
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03'
      })
    },
    // 傭車先
    filteredHacchusakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.hacchusakiFlg === true
      })
    },

    computedInputRows () {
      return this.rows.filter((elem) => { return ![undefined, null, '', '未選択'].includes(elem.jidoshaHyojiNm) }).length
    },

    computedColNumList () {
      var result = {}
      this.headers.forEach((elem, index) => {
        result[elem.name] = index
      })
      return result
    },
    isMultiSaveButtonDisabled () {
      if (this.modeKengen !== 2) {
        return false
      }
      const errorRows = this.rows.filter(function (elem) {
        return elem.editFlg === true && elem.errFlg === true
      })
      if (errorRows.length > 0) {
        return true
      }

      const saveTargetRow = this.rows.filter(function (elem) {
        return elem.editFlg === true
      })
      if (saveTargetRow.length < 1) {
        return true
      }
      return false
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msteigyosho', 'vwcmsteigyoshojininlist', 'vwcmstsharyo', 'mstshubetsu', 'msyskubun'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            self.setHeader()
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
            }
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
      const initConditions = {
        sagyoYoteiYmd: date.getCurrentDate(),
        haishahyoCd: null,
        eigyoshoId: indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyoshoCd, date.getCurrentDate()).id,
        tableStartHourDisp: '6:00',
        rangeDisp: this.rangeDisp
      }
      this.conditions = {
        ...initConditions
      }
      this.isAfterSearch = false
      this.searchText = ''
      this.rows = []
      this.page = 1
    },

    onClearButtonClick: function () {
      this.clear()
      this.setHeader()
    },
    clear: function () {
      this.initBindVariables()
      this.rows = []
      this.isConditionHide = false
    },
    onSearchButtonClick: function () {
      this.$nextTick(() => {
        this.searchAction(false)
      })
    },
    onRemoveConditionClick: function (itemNm) {
      this.conditions[itemNm] = null
      this.$nextTick(() => {
        this.searchAction(false)
      })
    },
    searchAction: function (noMessage) {
      this.rows = []
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2plmd1000/search', self.conditions)
              .then((data) => {
                self.setHeader()
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          const resultData = data.payload
          // 検索結果保持用にセット
          resultData.map((elem, index) => {
            // スプレッドシート用にここで編集
            elem.rowNo = index + 1
            elem.editFlg = false
            elem.errFlg = false
            elem.editMode = false

            // ここから表示用編集
            elem.sagyoYoteiYmd = filter.dateFormatter(elem.sagyoYoteiYmd)
            elem.hatsuchiYmd = ![undefined, null, ''].includes(elem.hatsuchiYmd) ? filter.dateFormatter(elem.hatsuchiYmd) : ''
            elem.hatsuchiHms = ![undefined, null, ''].includes(elem.hatsuchiHms) ? (elem.hatsuchiHms).slice(0, 5) : ''
            elem.chakuchiYmd = ![undefined, null, ''].includes(elem.chakuchiYmd) ? filter.dateFormatter(elem.chakuchiYmd) : ''
            elem.chakuchiHms = ![undefined, null, ''].includes(elem.chakuchiHms) ? (elem.chakuchiHms).slice(0, 5) : ''
            elem.seikyuYoteiYmd = ![undefined, null, ''].includes(elem.seikyuYoteiYmd) ? filter.dateFormatter(elem.seikyuYoteiYmd) : ''
            elem.shiharaiYoteiYmd = ![undefined, null, ''].includes(elem.shiharaiYoteiYmd) ? filter.dateFormatter(elem.shiharaiYoteiYmd) : ''

            // 請求金額・支払金額関数埋め込み
            const y = index + 1
            elem.seikyuKingakuGokeiFormula = ![undefined, null, ''].includes(self.seikyuKingakuGokeiFormula) ? '=' + self.seikyuKingakuGokeiFormula.replaceAll('{rowNo}', `${y}`) : ''
            elem.shiharaiKingakuGokeiFormula = ![undefined, null, ''].includes(self.shiharaiKingakuGokeiFormula) ? '=' + self.shiharaiKingakuGokeiFormula.replaceAll('{rowNo}', `${y}`) : ''

            return elem
          })
          self.rows = resultData

          // 検索条件設定
          self.conditions.haishaEigyoshoNm = ![undefined, null, ''].includes(self.conditions.eigyoshoId) ? indexeddb.getRecord(self.eigyoshoList, self.conditions.eigyoshoId).eigyoshoNm : ''

          self.isConditionHide = true
          self.isAfterSearch = true
        },
        isNoMessageModeMethod: function () {
          return noMessage
        },
        getSavedInputMethod: function () {
          return {}
        },
        failureValidateMethod: function () {
          self.torikomiConditonsRequired = true
          self.tableRowRequired = true
        }
      }
      this.search(opt)
    },
    // 検索前チェック
    searchValidate: function () {
      return true
    },

    // 登録前チェック
    registerValidate: function () {
      return true
    },

    /**
     * 一覧ヘッダ作成
     */
    setHeader: function () {
      const self = this
      return new Promise(resolve => {
        // 現在日付取得
        // const target = filter.dateFormatter(new Date())

        // 営業所コード取得
        // const me = indexeddb.getRecord(self.eigyoshoList, self.conditions.eigyoshoId)

        // --------------------------------------------------------------------------------
        // スプレッド用ドロップダウン作成
        // --------------------------------------------------------------------------------
        // 営業所
        /*
        var wkEigyoshoList = ['未選択']
        const mEigyoshoLisst = this.eigyoshoList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter(function (elem) {
          return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03'
        })
        const tEigyoshoList = mEigyoshoLisst.map(elem => {
          return elem.eigyoshoNm
        })
        wkEigyoshoList = wkEigyoshoList.concat(tEigyoshoList)

        // 乗務員
        var wkJomuinList = ['未選択']
        const mJomuinList = this.eigyoshoJininList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter(function (elem) {
          return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoCd === me.eigyoshoCd && elem.jomuFlg === true
        })
        const tJomuinList = mJomuinList.map(elem => {
          return elem.jininNmSei
        })
        wkJomuinList = wkJomuinList.concat(tJomuinList)

        // 車両
        var wkSharyoList = ['未選択']
        const mSharyoList = this.sharyoList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter(function (elem) {
          return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
        })
        const tSharyoList = mSharyoList.map(elem => {
          return elem.jidoshaHyojiNm
        })
        wkSharyoList = wkSharyoList.concat(tSharyoList)
        */
        // 点呼方法
        var wkHaishasakiList = ['対面', '電話', 'IT点呼']

        // --------------------------------------------------------------------------------
        // スプレッド用ヘッダ作成
        // --------------------------------------------------------------------------------
        self.headers = [
          // 各列の定義
          { type: 'text', title: '車両', width: '120px' },
          { type: 'text', title: '運転者名', width: '120px' },
          { type: 'text', title: '運行区間\n記号等', width: '150px' },
          { type: 'text', title: '点呼\n時刻', width: '80px' },
          { type: 'dropdown', title: '点呼\n方法', width: '80px', source: wkHaishasakiList, autocomplete: true },
          { type: 'checkbox', title: 'ｱﾙｺｰﾙ検知器\n使用の有無', width: '100px' },
          { type: 'text', title: 'ｱﾙｺｰﾙ検知器\n測定結果', width: '100px' },
          { type: 'checkbox', title: '確認事項\n①②③④', width: '80px' },
          { type: 'text', title: '日常\n点検', width: '80px' },
          { type: 'text', title: '点呼\nその他', width: '80px' },
          { type: 'text', title: '指示事項\nその他\n必要事項', width: '150px' },
          { type: 'text', title: '点呼\n時刻', width: '80px' },
          { type: 'dropdown', title: '点呼\n方法', width: '80px', source: wkHaishasakiList, autocomplete: true },
          { type: 'checkbox', title: 'ｱﾙｺｰﾙ検知器\n使用の有無', width: '100px' },
          { type: 'text', title: 'ｱﾙｺｰﾙ検知器\n測定結果', width: '100px' },
          { type: 'checkbox', title: '確認事項\n①②③④', width: '80px' },
          { type: 'text', title: '報告\n事項', width: '100px' },
          { type: 'text', title: '点呼\n執行者', width: '100px' }
        ]
        this.nestedHeaders = [
          [
            {
              title: '配車記録',
              colspan: 3 // '乗務員番号'から'運行区間記号等'まで
            },
            {
              title: '乗務前点呼',
              colspan: 8 // '点呼時刻'から'指示事項その他必要事項'まで
            },
            {
              title: '乗務後点呼',
              colspan: 8 // '点呼時刻'から'点呼執行者'まで
            }
          ]
        ]

        resolve()
      })
    },

    /**
     *
     */
    setReadonlyCell: function (rowData, columnName) {
      if (this.isShoukaiMode) {
        return true
      }
      /*
      if (columnName === 'jidoshaHyojiNm' && rowData.haishaKbnNm === '傭車') {
        return true
      }
      if (columnName === 'hacchusakiNm' && rowData.haishaKbnNm === '自社') {
        return true
      }
      */

      if (['juchuNo', 'sagyoMeisaiNo', 'unkoJissekiNo'].includes(columnName)) {
        return true
      }

      return false
    },

    // 行追加 上
    rowAppendAvobe: function (num) {
      this.rowAppend(num, true)
    },
    // 行追加
    rowAppend: function (num, aboveFlg) {
      // 現在の選択セル
      var activeC = this.$refs.ddSpreadSheet.getActiveCell()
      // 行追加先の位置を取得
      var pos = 0
      // 全選択状態なら先頭行に追加
      var isAllSelect = false
      if (!activeC) {
        // セル未選択
      } else if (activeC.length > 3) {
        // セル選択
        pos = Math.max(...[activeC[1], activeC[3]]) + 1

        // 全選択かどうか判定
        var isSame1 = activeC[0] === 0
        var isSame2 = activeC[1] === 0
        var isSame3 = activeC[2] === this.headers.length - 1
        var isSame4 = activeC[3] === this.rows.length - 1
        isAllSelect = isSame1 && isSame2 && isSame3 && isSame4
      }

      var newrow = this.setNewRow()

      // 行追加
      if (isAllSelect || (aboveFlg !== undefined && aboveFlg)) {
        if (pos === 0) {
          this.rows.unshift(newrow)
          pos = 0
        } else {
          this.rows.splice(pos - 1, 0, newrow)
          pos = pos - 1
        }
      } else {
        if (![undefined, null].includes(pos)) {
          this.rows.splice(pos, 0, newrow)
        } else {
          this.rows.splice(this.rows.length, 0, newrow)
        }
      }

      // 行番号が狂うので外部からのエラー設定は消去
      this.outsideErrorList = []

      // 行追加後のセルを選択状態にしてあげる…準備
      this.selectTargetPosition = pos + 1

      // 画面への再描写 ※強制発火用にspliceを実行
      // this.rows.splice()
    },
    onLoadDataAfter () {
      // このタイミングでやるのがまぁ正しいんでしょう
      /*
      if (this.selectTargetPosition !== null) {
        this.$refs.ddSpreadSheet.setActiveCell(0, this.selectTargetPosition)
        this.selectTargetPosition = null
      }
      */
      const self = this
      // 50行作成
      self.$nextTick(function () {
        for (let n = self.rows.length; n < 25; n++) {
          self.rowAppend(null, false)
        }
      })
    },
    setNewRow () {
      const userEigyoshoNm = indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyoshoCd, date.getCurrentDate()).eigyoshoNm
      this.wkUnkoJissekiId -= 1
      return {
        rowNo: this.rows.length + 1,
        id: this.wkUnkoJissekiId,
        trSagyoJissekiId: this.wkUnkoJissekiId,
        trKintaiJissekiId1: this.wkUnkoJissekiId,
        trKintaiJissekiId2: this.wkUnkoJissekiId,
        editFlg: false,
        errFlg: false,
        editMode: false,
        relation: '▼',
        CollectTrUnkoJissekiId: this.wkUnkoJissekiId,
        // 運行実績
        unkoJissekiNo: null,
        unkoYmd: date.getCurrentDate(),
        haishaEigyoshoNm: userEigyoshoNm,
        haishaKbnNm: '自社',
        hacchusakiNm: null,
        jomuinJininNmSei: null,
        joshuJininNmSei: null,
        jidoshaHyojiNm: null,
        jissekiShukkoYmd: null,
        jissekiShukkoHms: null,
        jissekiKikoYmd: null,
        jissekiKikoHms: null,
        hatsuchiOdoMater: null,
        chakuchiOdoMater: null,
        sokoKyori: null,
        kushaKyori: null,
        jisshaKyori: null,
        sosekisairyo: null,
        // 受注
        juchuNo: null,
        juchuEigyoshoNm: userEigyoshoNm,
        tokuisakiNm: null,
        chmonNo: null,
        hatsuchiNm: null,
        hatsuchiYmd: null,
        hatsuchiHms: null,
        chakuchiNm: null,
        chakuchiYmd: null,
        chakuchiHms: null,
        hinmeiNm: null,
        juchuSuryo: null,
        unitKbnNm: null,
        juchuJuryo: null,
        tanka: null,
        seikyuYoteiYmd: null,
        unchinKeisanKbnNm: '車建',
        seikyuShashuSbtNm: null,
        kihonUnchin: null,
        hiwayPrice: null,
        unchinHokaKingaku: null,
        unchinHokaHikazei: null,
        jikanWarimashiKingaku: null,
        kyoriWarimashiKingaku: null,
        warimashiSonotaKingsku: null,
        seikyuKingakuGokei: null,
        seikyuBiko: null,
        shiharaiYoteiYmd: null,
        yoshaKihonUnchin: null,
        yoshaHiwayPrice: null,
        yoshaUnchinHokaKingaku: null,
        yoshaUnchinHokaHikazei: null,
        shiharaiKingakuGokei: null,
        // 乗務員勤怠
        jomuinShukkinYmd: null,
        jomuinShukkinHms: null,
        jomuinTaikinYmd: null,
        jomuinTaikinHms: null,
        jomuinKosokuJikan: null,
        jomuinKyukeiJikan: null,
        jomuinKadouJikan: null,
        // 同乗者勤怠
        joshuShukkinYmd: null,
        joshuShukkinHms: null,
        joshuTaikinYmd: null,
        joshuTaikinHms: null,
        joshuKosokuJikan: null,
        joshuKyukeiJikan: null,
        joshuKadouJikan: null
      }
    },

    /**
     * スプレッドシート変更後イベント
     * @param {*} rowData
     * @param {*} cell
     * @param {*} x
     * @param {*} y
     * @param {*} newValue
     * @param {*} oldValue
     */
    changeAfter (rowData, cell, x, y, newValue, oldValue) {
      // console.log('c', rowData, cell, x, y, newValue, oldValue)
      /*
      const keyInfo = this.rows[y].unkoJissekiNo
      const changeColumnNm = this.headers[x].name
      const changeColumnNo = this.headers[x].columnNo
      */

      // console.log('change After :', keyInfo, '/', changeColumnNm, 'x is ', x, ', y is ', y, ', value is ', oldValue, ' -> ', newValue)

      /*
      // 実績周りのカラムの場合、同一運行実績Noは全て変更扱いにする
      if (changeColumnNo < 400 || changeColumnNo > 900) {
        this.rows.filter(x => x.unkoJissekiNo === keyInfo).map(x => {
          x[changeColumnNm] = newValue
          x.editFlg = true
          return x
        })
      }
      */

      if (Number(x) === this.computedColNumList.haishaKbnNm) {
        console.log('change After :', this.computedColNumList.jidoshaHyojiNm, this.computedColNumList.hacchusakiNm)
        // 配車先毎入力制御
        if (newValue === '自社') {
          this.$refs.ddSpreadSheet.setCellReadonly(this.computedColNumList.jidoshaHyojiNm, y, false)
          this.$refs.ddSpreadSheet.setCellReadonly(this.computedColNumList.hacchusakiNm, y, true)
        } else if (newValue === '傭車') {
          this.$refs.ddSpreadSheet.setCellReadonly(this.computedColNumList.jidoshaHyojiNm, y, true)
          this.$refs.ddSpreadSheet.setCellReadonly(this.computedColNumList.hacchusakiNm, y, false)
        }
      }
    },
    /**
     * 行追加後イベント
     * @param {} rowNumber
     */
    rowAddAfter (rowNumber) {
      // 背景色設定
      /*
      if (this.rows[rowNumber].id < 0) {
        const self = this
        this.headers.forEach((elem, index) => {
          self.$refs.ddSpreadSheet.setCellClass(index, rowNumber, 'changeCell')
        })
      }
      */
    },

    /**
     * 保存処理（ソースが酷いのでそのうち直す）
     * @returns
     */
    onMultiSaveButtonClick: function () {
      const self = this

      // 変更フラグONのみ対象
      const saveTargetRow = this.rows.filter(function (elem) {
        return elem.editFlg === true && elem.errFlg !== true
      })
      if (saveTargetRow.length < 1) { return }

      // DB保存用変換
      saveTargetRow.map((elem) => {
        // HHMMから秒に変換
        elem.jomuinKosokuJikan = ![null, ''].includes(elem.jomuinKosokuJikanHm) ? filter.timeToMinFormatter(elem.jomuinKosokuJikanHm) : null
        elem.jomuinKyukeiJikan = ![null, ''].includes(elem.jomuinKyukeiJikanHm) ? filter.timeToMinFormatter(elem.jomuinKyukeiJikanHm) : null
        elem.jomuinKadouJikan = ![null, ''].includes(elem.jomuinKadouJikanHm) ? filter.timeToMinFormatter(elem.jomuinKadouJikanHm) : null
        elem.joshuKosokuJikan = ![null, ''].includes(elem.joshuKosokuJikanHm) ? filter.timeToMinFormatter(elem.joshuKosokuJikanHm) : null
        elem.joshuKyukeiJikan = ![null, ''].includes(elem.joshuKyukeiJikanHm) ? filter.timeToMinFormatter(elem.joshuKyukeiJikanHm) : null
        elem.joshuKadouJikan = ![null, ''].includes(elem.joshuKadouJikanHm) ? filter.timeToMinFormatter(elem.joshuKadouJikanHm) : null

        // 数値変換
        elem.hatsuchiOdoMater = ![null, ''].includes(elem.hatsuchiOdoMater) ? d2fmt.removeComma(elem.hatsuchiOdoMater) : null
        elem.chakuchiOdoMater = ![null, ''].includes(elem.chakuchiOdoMater) ? d2fmt.removeComma(elem.chakuchiOdoMater) : null
        elem.sokoKyori = ![null, ''].includes(elem.sokoKyori) ? d2fmt.removeComma(elem.sokoKyori) : null
        elem.kushaKyori = ![null, ''].includes(elem.kushaKyori) ? d2fmt.removeComma(elem.kushaKyori) : null
        elem.jisshaKyori = ![null, ''].includes(elem.jisshaKyori) ? d2fmt.removeComma(elem.jisshaKyori) : null
        elem.sosekisairyo = ![null, ''].includes(elem.sosekisairyo) ? d2fmt.removeComma(elem.sosekisairyo) : null
        elem.juchuSuryo = ![null, ''].includes(elem.juchuSuryo) ? d2fmt.removeComma(elem.juchuSuryo) : null
        elem.juchuJuryo = ![null, ''].includes(elem.juchuJuryo) ? d2fmt.removeComma(elem.juchuJuryo) : null
        elem.kihonUnchin = this.convertOutputStringToDecimal(elem.kihonUnchin)
        elem.tanka = ![null, ''].includes(elem.tanka) ? d2fmt.removeComma(elem.tanka) : null
        elem.hiwayPrice = ![null, ''].includes(elem.hiwayPrice) ? d2fmt.removeComma(elem.hiwayPrice) : null
        elem.unchinHokaKingaku = ![null, ''].includes(elem.unchinHokaKingaku) ? d2fmt.removeComma(elem.unchinHokaKingaku) : null
        elem.unchinHokaHikazei = ![null, ''].includes(elem.unchinHokaHikazei) ? d2fmt.removeComma(elem.unchinHokaHikazei) : null
        elem.jikanWarimashiKingaku = ![null, ''].includes(elem.jikanWarimashiKingaku) ? d2fmt.removeComma(elem.jikanWarimashiKingaku) : null
        elem.kyoriWarimashiKingaku = ![null, ''].includes(elem.kyoriWarimashiKingaku) ? d2fmt.removeComma(elem.kyoriWarimashiKingaku) : null
        elem.warimashiSonotaKingsku = ![null, ''].includes(elem.warimashiSonotaKingsku) ? d2fmt.removeComma(elem.warimashiSonotaKingsku) : null
        elem.yoshaKihonUnchin = ![null, ''].includes(elem.yoshaKihonUnchin) ? d2fmt.removeComma(elem.yoshaKihonUnchin) : null
        elem.yoshaHiwayPrice = ![null, ''].includes(elem.yoshaHiwayPrice) ? d2fmt.removeComma(elem.yoshaHiwayPrice) : null
        elem.yoshaUnchinHokaKingaku = ![null, ''].includes(elem.yoshaUnchinHokaKingaku) ? d2fmt.removeComma(elem.yoshaUnchinHokaKingaku) : null
        elem.yoshaUnchinHokaHikazei = ![null, ''].includes(elem.yoshaUnchinHokaHikazei) ? d2fmt.removeComma(elem.yoshaUnchinHokaHikazei) : null
        elem.seikyuKingakuGokei = this.convertOutputStringToDecimal(elem.seikyuKingakuGokei)
        elem.shiharaiKingakuGokei = this.convertOutputStringToDecimal(elem.shiharaiKingakuGokei)

        return elem
      })

      /**
       * リスト項目テキスト⇒ID/Code変換
       */
      // 配車営業所変換
      saveTargetRow.filter((elem) => {
        return ![undefined, null, ''].includes(elem.haishaEigyoshoNm)
      }).map((elem) => {
        const m = self.filteredEigyoshoList.filter(function (item) {
          return item.eigyoshoNm === elem.haishaEigyoshoNm
        })
        if (m.length > 0) {
          elem.eigyoshoId = m[0].id
        }
        return elem
      })

      // 売上営業所変換
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.juchuEigyoshoNm)
      }).map((elem) => {
        const m = self.filteredEigyoshoList.filter(function (item) {
          return item.eigyoshoNm === elem.juchuEigyoshoNm
        })
        if (m.length > 0) {
          elem.juchuEigyoshoId = m[0].id
        } else {
          elem.juchuEigyoshoId = null
        }
        return elem
      })

      // 配車先
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.haishaKbnNm)
      }).map((elem) => {
        if (elem.haishaKbnNm === '自社') {
          elem.haishaKbn = '02'
        } else if (elem.haishaKbnNm === '傭車') {
          elem.haishaKbn = '03'
        } else {
          elem.haishaKbn = null
        }
        return elem
      })

      // 発注先
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.hacchusakiNm)
      }).map((elem) => {
        const m = self.filteredHacchusakiList.filter(function (item) {
          return item.torihikisakiNm === elem.hacchusakiNm
        })
        if (m.length > 0) {
          elem.hacchusakiId = m[0].id
        } else {
          elem.hacchusakiId = null
        }
        return elem
      })

      // 傭車車種
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.hacchusakiShashuSbtNm)
      }).map((elem) => {
        const m = self.shubetsuList.filter(function (item) {
          return item.kaishaCd === self.currentKaishaCode && item.sbtShuruiCd === 'GVI011' && item.sbtNm === elem.hacchusakiShashuSbtNm
        })
        if (m.length > 0) {
          elem.hacchusakiShashuSbt = m[0].sbtCd
        } else {
          elem.hacchusakiShashuSbt = null
        }
        return elem
      })

      // 乗務員
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.jomuinJininNm)
      }).map((elem) => {
        const m = self.filteredJininList.filter(function (item) {
          return item.jininNmSei === elem.jomuinJininNm
        })
        if (m.length > 0) {
          elem.jomuinJininId = m[0].id
        } else {
          elem.jomuinJininId = null
        }
        return elem
      })

      // 同乗者
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.joshuJininNm)
      }).map((elem) => {
        const m = self.filteredJininList.filter(function (item) {
          return item.jininNmSei === elem.joshuJininNm
        })
        if (m.length > 0) {
          elem.joshuJininId = m[0].id
        } else {
          elem.joshuJininId = null
        }
        return elem
      })

      // 車両変換
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.jidoshaHyojiNm)
      }).map((elem) => {
        const m = self.sharyoList.filter(function (item) {
          return item.jidoshaHyojiNm === elem.jidoshaHyojiNm
        })
        if (m.length > 0) {
          elem.sharyoId = m[0].id
        } else {
          elem.sharyoId = null
        }
        return elem
      })

      // 受注営業所変換
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.juchuEigyoshoNm)
      }).map((elem) => {
        const m = self.filteredEigyoshoList.filter(function (item) {
          return item.eigyoshoNm === elem.juchuEigyoshoNm
        })
        if (m.length > 0) {
          elem.juchuEigyoshoId = m[0].id
        } else {
          elem.juchuEigyoshoId = null
        }
        return elem
      })

      // 荷主
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.tokuisakiNm)
      }).map((elem) => {
        const m = self.filteredTokuisakiList.filter(function (item) {
          return item.torihikisakiNm === elem.tokuisakiNm
        })
        if (m.length > 0) {
          elem.tokuisakiId = m[0].id
        } else {
          elem.tokuisakiId = null
        }
        return elem
      })

      // 発地
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.hatsuchiNm)
      }).map((elem) => {
        const m = self.filteredHacchakuchiList.filter(function (item) {
          return item.hacchakuchiNm === elem.hatsuchiNm
        })
        if (m.length > 0) {
          elem.hatsuchiId = m[0].id
        } else {
          elem.hatsuchiId = null
        }
        return elem
      })

      // 着地
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.chakuchiNm)
      }).map((elem) => {
        const m = self.filteredHacchakuchiList.filter(function (item) {
          return item.hacchakuchiNm === elem.chakuchiNm
        })
        if (m.length > 0) {
          elem.chakuchiId = m[0].id
        } else {
          elem.chakuchiId = null
        }
        return elem
      })

      // 商品
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.hinmeiNm)
      }).map((elem) => {
        const m = self.filteredHinmeiList.filter(function (item) {
          return item.hinmeiNm === elem.hinmeiNm
        })
        if (m.length > 0) {
          elem.mstHinmeiId = m[0].id
        } else {
          elem.mstHinmeiId = null
        }
        return elem
      })

      // 単位
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.unitKbnNm)
      }).map((elem) => {
        const m = self.shubetsuList.filter(function (item) {
          return item.kaishaCd === self.currentKaishaCode && item.sbtShuruiCd === 'SVI001' && item.sbtNm === elem.unitKbnNm
        })
        if (m.length > 0) {
          elem.unitKbn = m[0].sbtCd
        } else {
          elem.unitKbn = null
        }
        return elem
      })

      // 運賃計算区分
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.unchinKeisanKbnNm)
      }).map((elem) => {
        const m = self.kubunList.filter(function (item) {
          return item.kaishaCd === self.currentKaishaCode && item.kbnShuruiCd === 'SFF055' && item.codeNm === elem.unchinKeisanKbnNm
        })
        if (m.length > 0) {
          elem.unchinKeisanKbn = m[0].code
        } else {
          elem.unchinKeisanKbn = null
        }
        return elem
      })

      // 請求車種
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.seikyuShashuSbtNm)
      }).map((elem) => {
        const m = self.shubetsuList.filter(function (item) {
          return item.kaishaCd === self.currentKaishaCode && item.sbtShuruiCd === 'GVI011' && item.sbtNm === elem.seikyuShashuSbtNm
        })
        if (m.length > 0) {
          elem.seikyuShashuSbt = m[0].sbtCd
        } else {
          elem.seikyuShashuSbt = null
        }
        return elem
      })

      /**
       * 保存処理
       */
      this.targetList = saveTargetRow
      this.$nextTick(function () {
        self.saveAction()
      })
    },

    saveAction: function () {
      const self = this
      const opt = {
        registerRequestPromise: function () {
          return self.HttpClient.post('/api/v1/VwCD2prmd0030/RegisterMulti', self.targetList)
        },
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.Effects.loadComplete()

            this.$nextTick(function () {
              this.searchAction(true)
            })
            resolve()
          })
        },
        getIdMethod: () => {
          return 0
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0
          }
        },
        isUpdateModeMethod: function () {
          return true
        },
        isNoRefreshModeMethod: function () {
          return true
        },
        isNoMessageModeMethod: function () {
          return false
        },
        getSavedInputMethod: function () {
          return true
        }
      }
      this.register(opt)
    },
    convertOutputStringToDecimal: function (val) {
      if ([undefined, null, ''].includes(val)) return null
      if (!isNaN(val)) return val
      return d2fmt.removeComma(val.replace(' 円', ''))
    },

    /*
     * 運行日切り替え日付
     */
    sagyoYoteiYmdPrevNext: function (val) {
      this.conditions.sagyoYoteiYmd = val
    },
    onPrevNextButtonClick: function (val) {
      // this.conditions.sagyoYoteiYmd が 'YYYY/MM/DD' 形式の文字列であることを前提に処理
      const parts = String(this.conditions.sagyoYoteiYmd).split('/')
      if (parts.length !== 3) {
        console.error("運行日 の形式が 'YYYY/MM/DD' ではありません")
        return
      }

      const year = parseInt(parts[0], 10)
      const month = parseInt(parts[1], 10) - 1 // 月は0始まり
      const day = parseInt(parts[2], 10)

      const currentDate = new Date(year, month, day)

      if (isNaN(val)) {
        return
      }

      // 日数の加減算
      currentDate.setDate(currentDate.getDate() + Number(val))

      // 'YYYY/MM/DD' 形式で再フォーマット
      const yyyy = currentDate.getFullYear()
      const mm = String(currentDate.getMonth() + 1).padStart(2, '0')
      const dd = String(currentDate.getDate()).padStart(2, '0')

      this.conditions.sagyoYoteiYmd = `${yyyy}/${mm}/${dd}`

      const self = this
      this.$nextTick(() => {
        self.searchAction(false)
      })
    },

    /**
     * EXCEL出力
     */
    onXlsOutputButtonClick: function (e) {
      var idList = []
      this.rows.forEach((x) => {
        idList.push(x.id)
      })
      const outputInfo = {
        idList: idList
      }

      this.Effects.loadStart()

      const self = this
      this.HttpClient
        .requestFileByPost('/api/v1/VwCD2prmd0030/ExcelOutput', outputInfo)
        .then((data) => {
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const elem = document.getElementById('xlsdownload')
          self.Effects.loadComplete()
          elem.href = window.URL.createObjectURL(blob)
          elem.download = '日報一覧_' + ts + '.xlsx'
          elem.click()
        })
    },

    /**
     * テンプレートEXCELダウンロード
     */
    onClickDownloadTemplate: function () {
      this.HttpClient
        .requestFileByPost('/api/v1/MstXlsImportMapping/TemplateDownload')
        .then((data) => {
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const elem = document.getElementById('download')
          elem.href = window.URL.createObjectURL(blob)
          elem.download = 'template.xlsx'
          elem.click()
        })
    }
  }
}
